import { Alert } from '../../Components/Shared/Interfaces/Alert';
import { LookupItems } from '../../Models/LookupItems';
import { PreQualificationSubmissionInfo } from '../../Models/PreQualificationCredentials';
import { PreQualifyResult } from '../../Models/PreQualifyResult';
import { DealerApplicationSubmission } from '../../Models/DealerAppSubmission';
import { State } from '../../Models/State';
import { CustomerReferenceRelationship } from '../../Models/CustomerReferenceRelationship';
import { LeadSourceTrackingData } from '../../Models/LeadSourceParameters';
import { ApplicationSubmission } from '../../Models/ApplicationSubmission';
import { ApplicationWithTargetAssignedToId } from '../../Models/ApplicationWithTargetAssignedToId';
import { CreateApplicationFromFormResults } from "../../Models/CreateApplicationFromFormResults";
import {DownPaymentLinkRequest} from "../../Models/DownPaymentLinkRequest";
import {CuratedSiteDownPaymentRequestDetails} from "../../Models/CuratedSiteDownPaymentRequestDetails";

export const SIGN_OUT_USER = 'SIGN_OUT_USER'
export const SET_SELECTED_LANGUAGE_ID = 'SET_SELECTED_LANGUAGE_ID';
export const LOAD_LIBRARY = 'LOAD_LIBRARY';
export const LOAD_LIBRARY_SUCCESS = 'LOAD_LIBRARY_SUCCESS';
export const LOAD_STATES = 'LOAD_STATES';
export const LOAD_STATES_SUCCESS = 'LOAD_STATES_SUCCESS';
export const SUBMIT_PRE_QUALIFICATION = 'SUBMIT_PRE_QUALIFICATION';
export const SUBMIT_PRE_QUALIFICATION_SUCCESS = 'SUBMIT_PRE_QUALIFICATION_SUCCESS';
export const SET_PRE_QUALIFYING_FLAG = 'SET_PRE_QUALIFYING_FLAG';
export const SET_LOCATION_ID = 'SET_LOCATION_ID';
export const SET_TARGET_ASSIGNED_TO_ID_FOR_NEW_APPLICATIONS = 'SET_TARGET_ASSIGNED_TO_ID_FOR_NEW_APPLICATIONS';
export const SET_PRE_QUALIFICATION_RESULT = 'SET_PRE_QUALIFICATION_RESULT';
export const SUBMIT_DEALER_APPLICATION = 'SUBMIT_DEALER_APPLICATION';
export const SUBMIT_DEALER_APPLICATION_SUCCESS = 'SUBMIT_DEALER_APPLICATION_SUCCESS';
export const LOAD_CUSTOMER_REFERENCE_RELATIONSHIPS = 'LOAD_CUSTOMER_REFERENCE_RELATIONSHIPS';
export const LOAD_CUSTOMER_REFERENCE_RELATIONSHIPS_SUCCESS = 'LOAD_CUSTOMER_REFERENCE_RELATIONSHIPS_SUCCESS';
export const SET_CUSTOMER_PORTAL_LINK_ID = 'SET_CUSTOMER_PORTAL_LINK_ID';

// Selected language ID for displaying the correct language.
export interface SetSelectedLanguageIdAction {
  type: typeof SET_SELECTED_LANGUAGE_ID;
  payload: { languageId: string }
}

export const setSelectedLanguageId = (languageId: string): SetSelectedLanguageIdAction => {
  return {
    type: SET_SELECTED_LANGUAGE_ID,
    payload: { languageId }
  };
}

/************************  Begin Alert    ******************************/
export const SHOW_ALERT = 'SHOW_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
// Show Alert
export interface ShowAlertAction {
  type: typeof SHOW_ALERT;
  payload: { notification: Alert };
}
export const showAlert = (notification: Alert): ShowAlertAction => {
  return {
    type: SHOW_ALERT,
    payload: { notification }
  };
}

// Remove Alert
export interface RemoveAlertAction {
  type: typeof REMOVE_ALERT;
  payload: { notificationId: string };
}
export const removeAlert = (notificationId: string): RemoveAlertAction => {
  return {
    type: REMOVE_ALERT,
    payload: { notificationId }
  };
}

/************************   End Alert    ******************************/

export interface LoadLibraryAction {
  type: typeof LOAD_LIBRARY;
  payload: { clientId: string, locationId?: string }
}
export const loadLibrary = (clientId: string, locationId?: string): LoadLibraryAction => {
  return {
    type: LOAD_LIBRARY,
    payload: { clientId, locationId }
  }
}

export interface LoadLibrarySuccessAction {
  type: typeof LOAD_LIBRARY_SUCCESS;
  payload: LookupItems
}
export const loadLibrarySuccess = (lookupItems: LookupItems): LoadLibrarySuccessAction => {
  return {
    type: LOAD_LIBRARY_SUCCESS,
    payload: lookupItems
  }
}

export interface LoadStatesAction {
  type: typeof LOAD_STATES;
  payload: { customerPortalLinkId: string }
}

export const loadStates = (customerPortalLinkId: string) => {
  return {
    type: LOAD_STATES,
    payload: { customerPortalLinkId }
  }
}

export interface LoadStatesSuccessAction {
  type: typeof LOAD_STATES_SUCCESS;
  payload: { states: State[] }
}

export const loadStatesSuccess = (states: State[]): LoadStatesSuccessAction => {
  return {
    type: LOAD_STATES_SUCCESS,
    payload: { states }
  }
}

/** End Client Lookups */

export const PAGE_LOADING = 'PAGE_LOADING';

export interface SetIsLoadingAction {
  type: typeof PAGE_LOADING,
  payload: { isLoading: boolean }
};
export const setIsLoading = (isLoading: boolean): SetIsLoadingAction => {
  return {
    type: PAGE_LOADING,
    payload: { isLoading }
  }
};

export const CREATE_APPLICATION = 'CREATE_APPLICATION';
export const CREATE_APPLICATION_SUCCESS = 'CREATE_APPLICATION_SUCCESS';
export interface CreateApplicationAction {
  type: typeof CREATE_APPLICATION;
  payload: { 
    application: ApplicationSubmission, 
    clientId: string, 
    locationId: string | null, 
    useCuratedSite: boolean // dictates if it creates a curated site portal link after the application is created
  }
}
export const createApplication = (application: ApplicationSubmission, clientId: string, amsCode: string | null, useCuratedSite: boolean): CreateApplicationAction => {
  return {
    type: CREATE_APPLICATION,
    payload: { application, clientId, locationId: amsCode, useCuratedSite }
  }
}

export interface CreateApplicationSuccessAction {
  type: typeof CREATE_APPLICATION_SUCCESS;
  payload: CreateApplicationFromFormResults
}
export const createApplicationSuccess = (createApplicationFromFormResults: CreateApplicationFromFormResults): CreateApplicationSuccessAction => {
  return {
    type: CREATE_APPLICATION_SUCCESS,
    payload: createApplicationFromFormResults
  }
}

export const UPDATE_APPLICATION = 'UPDATE_APPLICATION';
export interface UpdateApplicationAction {
  type: typeof UPDATE_APPLICATION;
  payload: { application: ApplicationWithTargetAssignedToId, clientId: string, customerPortalLinkId: string, customerId: string | null }
}
export const updateApplication = (application: ApplicationWithTargetAssignedToId, clientId: string, customerPortalLinkId: string, customerId: string | null): UpdateApplicationAction => {
  return {
    type: UPDATE_APPLICATION,
    payload: { application, clientId, customerPortalLinkId, customerId }
  }
}
export const UPDATE_APPLICATION_SUCCESS = 'UPDATE_APPLICATION_SUCCESS';
export interface UpdateApplicationSuccessAction {
  type: typeof UPDATE_APPLICATION_SUCCESS;
  payload: CreateApplicationFromFormResults
}
export const updateApplicationSuccess = (createApplicationFromFormResults: CreateApplicationFromFormResults): UpdateApplicationSuccessAction => {
  return {
    type: UPDATE_APPLICATION_SUCCESS,
    payload: createApplicationFromFormResults
  }
}

export const SET_TOKEN = 'SET_TOKEN';
export interface SetTokenAction {
  type: typeof SET_TOKEN;
  payload: { token: string }
}
export const setToken = (token: string): SetTokenAction => {
  return {
    type: SET_TOKEN,
    payload: { token }
  }
}

export const SET_CLIENT = 'SET_CLIENT';
export interface SetClientAction {
  type: typeof SET_CLIENT;
  payload: { clientId: string }
}
export const setClient = (clientId: string): SetClientAction => {
  return {
    type: SET_CLIENT,
    payload: { clientId }
  }
}

export const UNSUSCRIBE_FROM_EMAILS = 'UNSUSCRIBE_FROM_EMAILS';
export interface UnsubscribeFromEmailsAction {
  type: typeof UNSUSCRIBE_FROM_EMAILS;
  payload: { clientId: string, emailAddress: string }
}
export const unsubscribeFromEmails = (clientId: string, emailAddress: string): UnsubscribeFromEmailsAction => {
  return {
    type: UNSUSCRIBE_FROM_EMAILS,
    payload: { clientId, emailAddress }
  }
}

export const UNSUSCRIBE_FROM_EMAILS_SUCCESS = 'UNSUSCRIBE_FROM_EMAILS_SUCCESS';
export interface UnsubscribeFromEmailsSuccessAction {
  type: typeof UNSUSCRIBE_FROM_EMAILS_SUCCESS;
  payload: { message: string }
}
export const unsubscribeFromEmailsSuccess = (message: string): UnsubscribeFromEmailsSuccessAction => {
  return {
    type: UNSUSCRIBE_FROM_EMAILS_SUCCESS,
    payload: { message }
  }
}

// BEGIN PRE-QUALIFICATION
export interface SubmitPreQualificationAction {
  type: typeof SUBMIT_PRE_QUALIFICATION;
  payload: { preQualifySubmissionInfo: PreQualificationSubmissionInfo, locationId: string | null }
}
export const submitPreQualification = (preQualifySubmissionInfo: PreQualificationSubmissionInfo, locationId: string | null): SubmitPreQualificationAction => {
  return {
    type: SUBMIT_PRE_QUALIFICATION,
    payload: { preQualifySubmissionInfo, locationId }
  }
}

export interface SubmitPreQualificationSuccessAction {
  type: typeof SUBMIT_PRE_QUALIFICATION_SUCCESS;
  payload: { result: PreQualifyResult }
}
export const submitPreQualificationSuccess = (result: PreQualifyResult): SubmitPreQualificationSuccessAction => {
  return {
    type: SUBMIT_PRE_QUALIFICATION_SUCCESS,
    payload: { result: result }
  }
}

// Set pre-qualification flag
export interface SetPreQualificationFlagAction {
  type: typeof SET_PRE_QUALIFYING_FLAG;
  payload: { flag: boolean }
}
export const setPreQualificationFlag = (flag: boolean): SetPreQualificationFlagAction => {
  return {
    type: SET_PRE_QUALIFYING_FLAG,
    payload: { flag }
  }
}

// END PRE-QUALIFICATION

// Set Location Id
export interface SetLocationIdAction {
  type: typeof SET_LOCATION_ID;
  payload: { locationId: string }
}
export const setLocationId = (locationId: string): SetLocationIdAction => {
  return {
    type: SET_LOCATION_ID,
    payload: { locationId }
  }
}

// Set targetAssignedToIdForNewApplications
export interface SetTargetAssignedToIdForNewApplicationsAction {
  type: typeof SET_TARGET_ASSIGNED_TO_ID_FOR_NEW_APPLICATIONS;
  payload: { targetAssignedToId: string }
}

export const setTargetAssignedToIdForNewApplications = (targetAssignedToId: string): SetTargetAssignedToIdForNewApplicationsAction => {
  return {
    type: SET_TARGET_ASSIGNED_TO_ID_FOR_NEW_APPLICATIONS,
    payload: { targetAssignedToId }
  }
}

// Set Lead Source Tracking Data
export const SET_LEAD_SOURCE_TRACKING_DATA = 'SET_LEAD_SOURCE_TRACKING_DATA';
export interface SetLeadSourceTrackingDataAction {
  type: typeof SET_LEAD_SOURCE_TRACKING_DATA;
  payload: { leadSourceTrackingInfo: LeadSourceTrackingData }
}

export const setLeadSourceTrackingData = (leadSourceTrackingInfo: LeadSourceTrackingData): SetLeadSourceTrackingDataAction => {
  return {
    type: SET_LEAD_SOURCE_TRACKING_DATA,
    payload: { leadSourceTrackingInfo: leadSourceTrackingInfo }
  }
}

// Set pre-qualification result
export interface SetPreQualificationResultAction {
  type: typeof SET_PRE_QUALIFICATION_RESULT;
  payload: { result: PreQualifyResult | null }
}
export const setPreQualificationResult = (result: PreQualifyResult | null): SetPreQualificationResultAction => {
  return {
    type: SET_PRE_QUALIFICATION_RESULT,
    payload: { result }
  }
}

// *** Dealer App Actions ***
export interface SubmitDealerApplicationAction {
  type: typeof SUBMIT_DEALER_APPLICATION;
  payload: { application: DealerApplicationSubmission, clientId: string }
}

export const submitDealerApplication = (application: DealerApplicationSubmission, clientId: string): SubmitDealerApplicationAction => {
  return {
    type: SUBMIT_DEALER_APPLICATION,
    payload: { application, clientId }
  }
}

export interface SubmitDealerApplicationSuccessAction {
  type: typeof SUBMIT_DEALER_APPLICATION_SUCCESS;
}

export const submitDealerApplicationSuccess = (): SubmitDealerApplicationSuccessAction => {
  return {
    type: SUBMIT_DEALER_APPLICATION_SUCCESS
  };
}

export interface LoadCustomerReferenceRelationshipsAction {
  type: typeof LOAD_CUSTOMER_REFERENCE_RELATIONSHIPS;
  payload: { customerPortalLinkId: string }
}

export const loadCustomerReferenceRelationships = (customerPortalLinkId: string): LoadCustomerReferenceRelationshipsAction => {
  return {
    type: LOAD_CUSTOMER_REFERENCE_RELATIONSHIPS,
    payload: { customerPortalLinkId }
  };
}

export interface LoadCustomerReferenceRelationshipsSuccessAction {
  type: typeof LOAD_CUSTOMER_REFERENCE_RELATIONSHIPS_SUCCESS;
  payload: { customerReferenceRelationships: CustomerReferenceRelationship[] }
}

export const loadCustomerReferenceRelationshipsSuccess = (customerReferenceRelationships: CustomerReferenceRelationship[]): LoadCustomerReferenceRelationshipsSuccessAction => {
  return {
    type: LOAD_CUSTOMER_REFERENCE_RELATIONSHIPS_SUCCESS,
    payload: { customerReferenceRelationships }
  };
}

export interface SetCustomerPortalLinkIdAction {
  type: typeof SET_CUSTOMER_PORTAL_LINK_ID;
  payload: { customerPortalLinkId: string }
}

export const setCustomerPortalLinkId = (customerPortalLinkId: string): SetCustomerPortalLinkIdAction => {
  return {
    type: SET_CUSTOMER_PORTAL_LINK_ID,
    payload: { customerPortalLinkId }
  }
}

// Create Down Payment Link
export const CREATE_DOWN_PAYMENT_LINK = 'CREATE_DOWN_PAYMENT_LINK';
export interface CreateDownPaymentLinkAction {
  type: typeof CREATE_DOWN_PAYMENT_LINK;
  payload: DownPaymentLinkRequest
}

export const createDownPaymentLink = (downPaymentLinkRequest: DownPaymentLinkRequest): CreateDownPaymentLinkAction => {
  return {
    type: CREATE_DOWN_PAYMENT_LINK,
    payload: downPaymentLinkRequest
  }
}

export const CREATE_DOWN_PAYMENT_LINK_SUCCESS = 'CREATE_DOWN_PAYMENT_LINK_SUCCESS';

export interface CreateDownPaymentLinkSuccessAction {
  type: typeof CREATE_DOWN_PAYMENT_LINK_SUCCESS;
  payload: CuratedSiteDownPaymentRequestDetails
}

export const createDownPaymentLinkSuccess = (curatedSiteDownPaymentRequestDetails: CuratedSiteDownPaymentRequestDetails): CreateDownPaymentLinkSuccessAction => {
  return {
    type: CREATE_DOWN_PAYMENT_LINK_SUCCESS,
    payload: curatedSiteDownPaymentRequestDetails
  }
}

export const SET_IS_LOADING_DOWN_PAYMENT_LINK = 'SET_IS_LOADING_DOWN_PAYMENT_LINK';
export interface SetIsLoadingDownPaymentLinkAction {
  type: typeof SET_IS_LOADING_DOWN_PAYMENT_LINK;
  payload: { isLoading: boolean }
}

export const SetIsLoadingDownPaymentLink = (isLoading: boolean): SetIsLoadingDownPaymentLinkAction => {
  return {
    type: SET_IS_LOADING_DOWN_PAYMENT_LINK,
    payload: { isLoading }
  }
}


export type SharedAction =
  | LoadLibrarySuccessAction
  | LoadStatesAction
  | LoadStatesSuccessAction
  | SetIsLoadingAction
  | CreateApplicationSuccessAction
  | UpdateApplicationSuccessAction
  | SetTokenAction
  | ShowAlertAction
  | RemoveAlertAction
  | SetClientAction
  | UnsubscribeFromEmailsSuccessAction
  | SubmitPreQualificationSuccessAction
  | SubmitPreQualificationAction
  | SetPreQualificationFlagAction
  | SetLocationIdAction
  | SetPreQualificationResultAction
  | SubmitDealerApplicationAction
  | SubmitDealerApplicationSuccessAction
  | LoadCustomerReferenceRelationshipsAction
  | LoadCustomerReferenceRelationshipsSuccessAction
  | SetCustomerPortalLinkIdAction
  | SetSelectedLanguageIdAction
  | SetTargetAssignedToIdForNewApplicationsAction
  | CreateDownPaymentLinkAction
  | CreateDownPaymentLinkSuccessAction
  | SetIsLoadingDownPaymentLinkAction
  | SetLeadSourceTrackingDataAction;
